
define('text!templates/appMain/privilegedMain/composer/forms/formEditor/visibilityCombiningOperationPicker.html',[],function () { return '<div class="visibility-operator">\n    <select data-bind="options: combiningOperationOptions, optionsText: &apos;displayName&apos;, value: selectedCombiningOperation"></select>\n</div>';});

